<template>
  <div style="margin-top:20px;">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="用户类型" style="margin-right:15px">
        <span v-if="form.partyType == 'SHIPMENT'">托运人</span>
        <span v-else-if="form.partyType == 'PLAT'">平台</span>
        <span v-else>平台/托运人</span>
      </el-form-item>
      <el-form-item label="付款方" prop="phone" style="margin-right:15px">
        <el-col :span="18">
          <el-input
            v-model="form.name"
            disabled="disabled"
            placeholder="请选择付款方"
          />
        </el-col>
        <el-col :span="2" style="margin-left:15px">
          <el-button type="primary" @click="vardel = true">选择</el-button>
        </el-col>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>
    <vxe-modal
      v-model="vardel"
      width="800"
      height="80%"
      title="选择付款方"
      resize
    >
      <!-- v-if 解决表格无法铺满弹框问题 -->
      <Selectuser v-if="vardel" ref="ShipperlRef" @event1="receive" />
    </vxe-modal>
  </div>
</template>
<script>
import Selectuser from "./components/Selectuser.vue";
import { CollectionCode } from "@/api/collectioncoding";
export default {
  name: "CodingAdd",
  components: {
    Selectuser
  },
  props: {
    cascadeData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      emptyForm: {},
      vardel: false,
      form: {
        name: ""
      }
    };
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    receive(data) {
      this.form = data;
      this.vardel = false;
    },
    // 获取页面信息
    getInfo() {
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      this.$refs.form.resetFields();
    },
    // 提交
    funcSubmit() {
      const data = {
        partyType: this.form.partyType,
        payerName: this.form.name,
        partyCode: this.form.code
      };
      const rLoading = this.openLoading();
      return new Promise(resolve => {
        CollectionCode(data).then(response => {
          rLoading.close();
          this.$message({
            message: response.msg,
            type: "success"
          });
          this.$emit("fatherEditMethod");
          resolve();
        });
      });
      // let method = 'post'
      // request({
      //   url: "/ntocc-tms-api/myBankV2CollectionCode",
      //   method: method,
      //   data,
      // }).then((response) => {
      //   rLoading.close();
      //   this.$message({
      //     message: response.msg,
      //     type: "success",
      //   });
      //   this.$emit("fatherEditMethod");
      // });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
